import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OffcanvasService } from '../../services/offcanvas.service';

@Component({
  selector: 'app-offcanvas',
  templateUrl: './offcanvas.component.html',
  styleUrls: ['./offcanvas.component.scss']
})
export class OffcanvasComponent {

  @Input() idOffcanvas;
  @Input() titulo;
  @Input() btnVoltar = false;
  @Output() onClickVoltar: EventEmitter<any> = new EventEmitter();

  constructor(public offcanvas: OffcanvasService) {}
  voltar() {
    this.onClickVoltar.emit(true);
  }
}